﻿module.exports = [countryTypeaheadFilter];

// Takes care of ordering the results of the country typeahed. The logic is as follows:
// First, show the matches on the country code (first letter or both), ordered by code
// Next, show the matches on the beginning of the country name, ordered by name
// Finally, show the matches anywhere else in the name, ordered by name
// NB: this needs to be used in combination with a regular filter, since it does not take
// care of removing results which don't match the query at all
function countryTypeaheadFilter() {


    return function (countries, query) {
        if (query === null || query === undefined || query === '') {
            return _.sortBy(countries, 'name');
        }

        var countryCodeMatchPartition = _.partition(countries, country =>
            country.code && country.code.toLowerCase().indexOf(query.toLowerCase()) === 0
        );

        var nameStartMatchPartition = _.partition(countryCodeMatchPartition[1], country =>
            country.name && country.name.toLowerCase().indexOf(query.toLowerCase()) === 0
        );

        var nameMiddleMatchPartition = _.partition(nameStartMatchPartition[1], country =>
            country.name && country.name.toLowerCase().indexOf(query.toLowerCase()) > -1
        );

        var result = _.concat(
            _.sortBy(countryCodeMatchPartition[0], 'code'), 
            _.sortBy(nameStartMatchPartition[0], 'name'), 
            _.sortBy(nameMiddleMatchPartition[0], 'name'), 
            _.sortBy(nameMiddleMatchPartition[1], 'name')
        );
        return result;
    }
}
